<template>
  <div class="basic-layout">
    <!-- 左侧菜单 -->
    <div class="layout-sidebar">
      <NavigationMenu />
    </div>
    
    <!-- 右侧内容区 -->
    <div class="layout-content">
      <!-- 顶部栏 -->
      <div class="layout-header">
        <GlobalHeader />
      </div>
      
      <!-- 中间内容区 -->
      <div class="layout-main">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :key="$route.path" :is="Component" />
          </keep-alive>
        </router-view>
      </div>
      
      <!-- 底部 -->
      <div class="layout-footer">
        <GlobalFooter />
      </div>
    </div>
  </div>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu.vue'
import GlobalHeader from '@/components/GlobalHeader/index.vue'
import GlobalFooter from '@/components/GlobalFooter/index.vue'

export default {
  name: 'BasicLayout',
  components: {
    NavigationMenu,
    GlobalHeader,
    GlobalFooter
  }
}
</script>

<style scoped>
.basic-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.layout-sidebar {
  flex: 0 0 auto;
  height: 100vh;
  overflow: hidden;
}

.layout-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: #f0f2f5;
}

.layout-header {
  flex: 0 0 auto;
  background-color: #fff;
  z-index: 100;
}

.layout-main {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: #fff;
}

.layout-footer {
  flex: 0 0 auto;
  background-color: #fff;
  border-top: 1px solid #e6e6e6;
}
</style>
